import { render } from "./AvatarOptions.vue?vue&type=template&id=95bc424e"
import script from "./AvatarOptions.vue?vue&type=script&lang=js"
export * from "./AvatarOptions.vue?vue&type=script&lang=js"

import "./AvatarOptions.vue?vue&type=style&index=0&id=95bc424e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__